import Flickity from "../../node_modules/flickity";
import "flickity-fade";

document.addEventListener("alpine:init", () => {
    Alpine.data("AssociationsCarousel", () => ({
        carousel: null,
        navigation: null,
        index: 0,
        init() {
            this.initCarousel();
        },
        initCarousel() {
            if (!this.$refs.carousel) return;

            this.carousel = new Flickity(this.$refs.carousel, {
                on: {
                    ready: function () {
                        window.dispatchEvent(new Event("resize"));
                    },
                    change: (index) => {
                        this.updateIndex(index);
                    },
                },
            });

            this.navigation = new Flickity(this.$refs.navigation, {
                draggable: true,
                cellAlign: "left",
                on: {
                    ready: function () {
                        window.dispatchEvent(new Event("resize"));
                    },
                    change: (index) => {
                        this.updateIndex(index);
                        this.goToSlide(index);
                    },
                },
                asNavFor: this.carousel,
            });
        },
        goToSlide(index) {
            this.carousel.selectCell(index);
            this.navigation.selectCell(index);
        },
        prevSlide() {
            let index = this.carousel.selectedIndex - 1;

            if (index < 0) {
                index = 0;
            }

            this.carousel.selectCell(index);
            this.navigation.selectCell(index);
        },
        nextSlide() {
            let index = this.carousel.selectedIndex + 1;

            if (index >= this.carousel.cells.length) {
                index = this.carousel.cells.length - 1;
            }

            this.carousel.selectCell(index);
            this.navigation.selectCell(index);
        },
        updateIndex(index) {
            this.index = index;
        },
    }));
});
